import { render, staticRenderFns } from "./LockCard.vue?vue&type=template&id=1963c6d7&"
import script from "./LockCard.vue?vue&type=script&lang=js&"
export * from "./LockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1963c6d7')) {
      api.createRecord('1963c6d7', component.options)
    } else {
      api.reload('1963c6d7', component.options)
    }
    module.hot.accept("./LockCard.vue?vue&type=template&id=1963c6d7&", function () {
      api.rerender('1963c6d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/LockCard.vue"
export default component.exports